// extracted by mini-css-extract-plugin
export var brand = "_8a-9";
export var compact = "_8a-6";
export var extraSmall = "_8a-7";
export var icon = "_8a-0";
export var large = "_8a-4";
export var light = "_8a-1";
export var medium = "_8a-5";
export var outline = "_8a-b";
export var primaryDark = "_8a-a";
export var primaryLight = "_8a-8";
export var primaryModern = "_8a-c";
export var success = "_8a-2";
export var successSolid = "_8a-3";